module.exports = __webpack_public_path__ + "img/182.6a0e05fd.jpg";